import { useContext, useEffect, useState } from 'react';
import { client } from '../../hooks/Client';
import { useHistory } from "react-router-dom"
import { SavedIcon } from '../../StateManagment/SavedIcon';
import { ActiveMenu } from '../../StateManagment/ActiveMenuItem';
import Location from '../../hooks/Location';
import Hostname from '../../hooks/Hostname';
import useSettings from '../../hooks/Settings';
import SwitchAccount from '../common/SwitchAccount';
import { Auth } from '../../StateManagment/Auth';
import { useFirestoreNoCompagnyGeneralTwoOrderBy } from '../../firebase/useFirestore';
import { OnboardingTour } from '../../StateManagment/OnboardingTour';
import TopBarBreadCrumbs from '../common/TopBarBreadCrumb';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import Tooltip from "../../components/common/Tooltip";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import DeccaTopbarButton from '../AI/decca/DeccaTopbarButton';

const Topbar = () => {
    // Context
    const [auth] = useContext(Auth)
    const [saved, setSaved] = useContext(SavedIcon)
    const { step, setStep } = useContext(OnboardingTour);
    const { active, setActive, activeSubItem, setActiveSubItem } = useContext(ActiveMenu);

    // State
    const [display, setDisplay] = useState('block')
    const [displayTopbar, setDisplayTopbar] = useState('block')
    const [compagnyLogo, setCompagnyLogo] = useState(null)

    // Hooks
    const history = useHistory()
    const urlTwo = Location()[2]
    const urlOne = Location()[1]
    const urlFour = Location()[4]
    const urlSix = Location()[6]
    const urlSeven = Location()[7]
    const urlEight = Location()[8]
    const host = Hostname()
    // Eén aanroep, niet één per veld: useSettings() opent per aanroep eigen
    // Firestore-listeners (o.a. OutputEffects where Standard == 'true').
    const { subscription, compagnyName } = useSettings()
    const compagnies = auth?.Compagny || [];

    // Firestore
    const notifications = useFirestoreNoCompagnyGeneralTwoOrderBy('Notifications', 'Reciever', client, 'Read', false, 'Timestamp', 'desc');


    // Display logo and hide iconbar if client is not approved, not registered or not logged in
    const displayLogo = () => {
        if(client === '' || urlTwo === 'login' || urlOne === 'login' || urlOne === 'createaccount' || urlOne === 'impactplan' ){
            setDisplay('none')
        } else if(urlTwo === 'Register' || urlTwo === 'NotApproved' || urlTwo === 'RegisterInvitation'){
            setDisplay('none')
        } else{
            setDisplay('block')
        }
    }

    const showTopbar = () => {
        if( urlFour === 'open' || urlSix === 'open' || urlSeven === 'open' || urlEight === 'open'){
            setDisplayTopbar('none')
        } else{
            setDisplayTopbar('block')
        }
    }

    useEffect(() => {
        displayLogo()
    },[ client, urlTwo, urlOne, compagnyLogo, host ])

    useEffect(() => {
        showTopbar()
    },[urlFour, urlSix])

    return (
        <header id="top-bar-container" style={{display: displayTopbar}}>
            <div className="top-bar">
                <TopBarBreadCrumbs />
                <div id='topbar-icons-container'>

                    {/* Subscribtion */}
                    <div style={{display: subscription === 'free' ? 'flex' : 'none'}} id='subscribtion-container'>
                        <ArrowCircleUpOutlinedIcon onClick={() => history.push(`/${client}/subscription`)}/>
                        <p onClick={() => history.push(`/${client}/subscription`)}>Upgrade</p>
                    </div>

                    {/* ImpactAI (Decca) — page-agnostic chat entry point */}
                    <DeccaTopbarButton />

                    {/* Calendar */}
                    <div id='topbar-icon-container'>
                        <Tooltip content="Agenda" width='100%' top='60px'>
                            <TodayOutlinedIcon onClick={() => history.push(`/${client}/agenda`)}/>
                        </Tooltip>
                    </div>

                    {/* Notifications */}
                    <div id='topbar-icon-container'>
                        <Tooltip content="Notificaties" width='100%' top='60px'>
                            <NotificationsNoneOutlinedIcon onClick={() => history.push(`/${client}/notifications`)}/>
                            {notifications && notifications.length > 0 && (
                                <span className='topbar-icon-dot' />
                            )}
                        </Tooltip>
                    </div>

                    {/* Settings */}
                    <div id='topbar-icon-container'>
                        <Tooltip content="Instellingen" width='100%' top='60px'>
                            <SettingsOutlinedIcon onClick={() => history.push(`/${client}/settings`)}/>
                        </Tooltip>
                    </div>

                    {/* Profile — de organisatieregel onder de naam is de
                        omgevingswisselaar zelf zodra je er meer dan een hebt.
                        Avatar en naam gaan naar het profiel; de wisselaar mag
                        die klik NIET erven, vandaar de klik per element in
                        plaats van op het hele blok. */}
                    <div id='profile-menu-name-container'>
                        <div className='topbar-profile-row'>
                            <div
                                className='topbar-avatar'
                                onClick={() => history.push(`/${client}/profile`)}
                            >
                                {auth?.Photo ? (
                                    <img src={auth.Photo} alt={auth.ForName || ''} />
                                ) : (
                                    <span>
                                        {(auth?.ForName?.[0] || '').toUpperCase()}
                                        {(auth?.SurName?.[0] || '').toUpperCase()}
                                    </span>
                                )}
                            </div>
                            <div className='topbar-profile-text'>
                                <Tooltip content="Profiel" top='40px'>
                                    <p
                                        id='profile-menu-name'
                                        onClick={() => history.push(`/${client}/profile`)}
                                    >
                                        {auth && auth.ForName} {auth && auth.SurName}
                                    </p>
                                </Tooltip>
                                {compagnies.length > 1
                                    ? <SwitchAccount fallbackName={compagnyName} />
                                    : compagnyName && <p id='profile-menu-org'>{compagnyName}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Topbar
